import { client } from '@/client';
import { CourseChanges } from '@/client/courses/types/course-changes.type';
import { useQuery, UseQueryOptions } from 'react-query';

export const useCourseChanges = (
  accountId: string | undefined,
  courseId: string | undefined,
  options?: Omit<
    UseQueryOptions<CourseChanges, Error, CourseChanges, string[]>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery(
    ['course-changes', accountId || '', courseId || ''],
    () => {
      if (!accountId || !courseId) {
        throw new Error('Account ID and Course ID are required');
      }

      return client.courses.getCourseChanges(accountId, courseId);
    },
    {
      enabled: !!accountId && !!courseId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: false,
      ...options,
    },
  );
};
